<template>
  <div class="spinner-wrapper text-light">
    <div class="spinner-grow"></div>
    <p class="mb-0 mt-3">{{ message || "Loading..." }}</p>
  </div>
</template>

<script>
export default {
  name: "spinner",
  props: ["message"],
};
</script>
